<template>
  <div id="group-and-attr">
    <vs-button @click="addnewGroup()" class="bg_l_green mb-6">
      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
      {{ $t("CreateNewGroup") }}1
    </vs-button>
    <div
      class="vx-card p-15 mb-4"
      v-for="(group, groupIndex) in genericProduct.attributeGroups"
      :key="group"
    >
      <div class="vx-row top-row">
        <div class="vx-col w-full">
          <vs-input
            class="inputx mb-4 mt-1"
            :value="group.name"
            @input="(e) => updateAttributeGroupField(groupIndex, 'name', e)"
            name="attrGroupName"
            v-validate="'required'"
            v-bind:class="{ 'is-invalid': errors.has('attrGroupName') }"
            :placeholder="$t('PleaseEnterGroupName')"
          />

          <vs-input
            class="inputx mb-4 mt-1 vs-input-count"
            :value="group.priority"
            @input="(e) => updateAttributeGroupField(groupIndex, 'priority', e)"
            name="attrGroupPriority"
            v-validate="'required'"
            v-bind:class="{ 'is-invalid': errors.has('attrGroupPriority') }"
            :placeholder="$t('Priority')"
          />

          <vs-button
            radius
            color="danger"
            size="small"
            type="gradient"
            icon-pack="feather"
            icon="icon-x"
            @click.prevent="deleteAttributeGrroup(groupIndex)"
            class="d-inline float-right mt-2"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col lg:w-1/2 w-full">
          <v-select
            label="name"
            name="attrName"
            :options="allAttributes"
            :value="group.newpa_attributeId"
            @input="
              (e) =>
                updateAttributeGroupField(groupIndex, 'newpa_attributeId', e)
            "
            dir="rtl"
            v-validate="'required'"
            v-bind:class="{ 'is-invalid': errors.has('attrName') }"
            :placeholder="$t('SearchAttributes')"
          >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <v-select
            label="name"
            name="attrType"
            :options="attributeTypes"
            :value="group.newpa_attributeType"
            @input="
              (e) =>
                updateAttributeGroupField(groupIndex, 'newpa_attributeType', e)
            "
            v-validate="'required'"
            v-bind:class="{ 'is-invalid': errors.has('attrType') }"
            :reduce="(x) => x.id"
            :placeholder="$t('Type')"
            dir="rtl"
          >
          </v-select>
          <vs-button
            type="border"
            size="small"
            icon-pack="feather"
            icon="icon-plus"
            class="mr-2 add-c d-inline float-right mt-2"
            @click.prevent="addAttributeGroup(groupIndex, group)"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table
            :data="group.productAttributes"
            class="custom-tbl mt-4 mb-4 attribute-tbl"
          >
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(pa, i) in data">
                <template v-if="data[i].attribute.name">
                  <vs-td width="4%">
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td width="23%">
                    {{ data[i].attribute.name }}
                  </vs-td>
                  <vs-td width="23%">
                    {{
                      data[i].singleOptions != null
                        ? "تک گزینه ای"
                        : data[i].selectiveOptions != null
                        ? "چند گزینه‌ایی"
                        : "متنی"
                    }}
                  </vs-td>
                  <vs-td width="50%">
                    <span
                      v-if="data[i].singleOptions || data[i].selectiveOptions"
                      class="select-tag"
                    >
                      <vs-button
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="add-btn"
                        @click.prevent="
                          addOptions(data[i], {
                            groupIndex: groupIndex,
                            productIndex: i,
                          })
                        "
                        >{{ $t("Options") }}</vs-button
                      >
                    </span>
                    <button
                      @click.prevent="deleteAttr(i, groupIndex)"
                      class="d-inline removeBtn float-right"
                    >
                      <feather-icon
                        icon="XIcon"
                        svgClasses="h-4 w-4"
                        class="ico"
                      />
                    </button>
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mt-4">
        <button
          type="submit"
          class="float-right vs-component vs-button vs-button-primary vs-button-filled"
          @click.prevent="submitForm"
          :disabled="disabled"
        >
          {{ $t("Save") }}
        </button>
      </div>
    </div>
    <options-popup
      :show="OptionPopup"
      :model="modalModel"
      @finish="onfinish"
    ></options-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
  border: 1px solid #027572 !important;
  color: #027572 !important;
}

.add-btn i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}

.add-btn .vs-button-text:hover {
  color: #027572 !important;
}

#group-and-attr .add-btn.isActive {
  background-color: #fff !important;
  background: #fff !important;
}

#group-and-attr .add-btn.isActive span {
  background-color: #fff !important;
  background: #fff !important;
  color: #027572 !important;
}

#group-and-attr .submit-btn:hover {
  color: #fff;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import OptionsPopup from "./OptionsPopup.vue";

export default {
  data() {
    return {
      group: {
        name: "",
        attributeId: null,
        attributeType: "",
        selectiveOptionsCommand: {
          value: "",
          key: 0,
        },
      },
      attributeTypes: [
        { name: "تک گزینه‌ایی", id: 0 },
        { name: "چند گزینه‌ایی", id: 1 },
        { name: "متنی", id: 2 },
      ],
      OptionPopup: false,
      modalModel: {},
      modalMeta: { groupIndex: null, productIndex: null },
      disabled: false,
    };
  },
  mounted() {
    this.fetchAttributes();
  },
  computed: {
    ...mapGetters({
      allAttributes: "attribute/list",
      genericProduct: "genericProduct/details",
    }),
  },
  methods: {
    ...mapActions({
      fetchAttributes: "attribute/fetchNoSkip",
      submitData: "genericProduct/submitData",
      attributeIsnotDuplicatedInProductAttributes:
        "genericProduct/attributeIsnotDuplicatedInProductAttributes",
      removeGroup: "genericProduct/removeGroup",
      removeProductAttribute: "genericProduct/removeProductAttribute",
    }),
    deleteAttr(index, groupId) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeProductAttribute({ gIndex: groupId, paIndex: index });
        }
      });
    },
    addAttributeGroup(index, group) {
      this.attributeIsnotDuplicatedInProductAttributes({
        attributeId: group.newpa_attributeId.id,
        groupIndex: index,
      })
        .then(() => {
          var pa = {
            attributeId: group.newpa_attributeId,
            attributeType: group.newpa_attributeType,
          };
          this.$store.commit(
            "genericProduct/addProductAttributeInAttributeGroupInDetails",
            { index, pa }
          );
          group.newpa_attributeId = null;
          /// group.newpa_attributeType = null;
        })
        .catch(() => {
          this.$swal({
            position: "center-center",
            type: "error",
            text: "صفت نمی تواند تکراری باشد!",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    deleteAttributeGrroup(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeGroup(index);
        }
      });
    },
    addnewGroup() {
      this.$store.commit("genericProduct/addAttributeGroupToDetails", {
        name: "",
        priority: "",
        productAttributes: [],
      });
    },
    submitForm() {
      this.disabled = true;
      this.submitData().then(() => {
        this.$router.push("/GenericProduct/Index");
        ///this.checkIfGroupExists();
      });
      this.disabled = false;
    },
    updateAttributeGroupField(index, field, value) {
      this.$store.commit("genericProduct/setAttributeGroupFieldsInDetails", {
        index,
        field,
        value,
      });
    },
    updateProductAttributesSelectiveOptions(groupIndex, productIndex, options) {
      this.$store.commit(
        "genericProduct/updateProductAttributesInAttributeGroupDetails",
        { groupIndex, productIndex, options }
      );
    },
    addOptions(data, meta) {
      this.OptionPopup = true;
      this.modalMeta = meta;
      this.modalModel = [
        ...(data.singleOptions ? data.singleOptions : data.selectiveOptions),
      ];
    },
    onfinish() {
      this.OptionPopup = false;
      this.updateProductAttributesSelectiveOptions(
        this.modalMeta.groupIndex,
        this.modalMeta.productIndex,
        this.modalModel
      );
      this.$validator.reset();
    },
  },

  components: {
    "v-select": vSelect,
    OptionsPopup,
  },
};
</script>
